// src/reducers/videoRenderReducer.js
import {
  START_VIDEO_RENDER_REQUEST,
  START_VIDEO_RENDER_SUCCESS,
  START_VIDEO_RENDER_FAILURE,
  GET_RENDER_PROGRESS_REQUEST,
  GET_RENDER_PROGRESS_SUCCESS,
  GET_RENDER_PROGRESS_FAILURE,
  GET_RENDER_DOWNLOAD_URL_REQUEST,
  GET_RENDER_DOWNLOAD_URL_SUCCESS,
  GET_RENDER_DOWNLOAD_URL_FAILURE,
  RESET_RENDER_STATE,
} from "../actions/videoRenderActions";

const initialState = {
  // Render start state
  renderStatus: "idle", // idle, starting, rendering, done, error
  renderId: null,
  bucketName: null,

  // Progress state
  progress: null, // 0.0 to 1.0
  progressType: null, // "progress" | "done" | "error"
  progressMessage: null,

  // Download URL state
  downloadUrl: null,
  downloadUrlExpiresIn: null,

  // Error state
  error: null,
};

const videoRenderReducer = (state = initialState, action) => {
  console.log("🔄 REDUCER: videoRenderReducer processing action:", {
    type: action.type,
    currentState: {
      renderStatus: state.renderStatus,
      renderId: state.renderId,
    },
    actionPayload: action.payload,
  });

  switch (action.type) {
    case START_VIDEO_RENDER_REQUEST:
      const newState1 = {
        ...state,
        renderStatus: "starting",
        renderId: null,
        bucketName: null,
        error: null,
        progress: null,
        progressType: null,
      };
      console.log(
        "🔄 REDUCER: START_VIDEO_RENDER_REQUEST → new state:",
        newState1
      );
      return newState1;

    case START_VIDEO_RENDER_SUCCESS:
      const newState2 = {
        ...state,
        renderStatus: "rendering",
        renderId: action.payload.renderId,
        bucketName: action.payload.bucketName || null,
        error: null,
        progress: 0,
        progressType: "progress",
      };
      console.log(
        "🔄 REDUCER: START_VIDEO_RENDER_SUCCESS → new state:",
        newState2
      );
      return newState2;

    case START_VIDEO_RENDER_FAILURE:
      const newState3 = {
        ...state,
        renderStatus: "error",
        error: action.payload,
        renderId: null,
        bucketName: null,
      };
      console.log(
        "🔄 REDUCER: START_VIDEO_RENDER_FAILURE → new state:",
        newState3
      );
      return newState3;

    case GET_RENDER_PROGRESS_REQUEST:
      console.log("🔄 REDUCER: GET_RENDER_PROGRESS_REQUEST → keeping state");
      return {
        ...state,
        // Keep existing state, just updating progress
      };

    case GET_RENDER_PROGRESS_SUCCESS:
      const progressData = action.payload;
      const newState4 = {
        ...state,
        progressType: progressData.type,
        progress: progressData.progress || state.progress,
        progressMessage: progressData.message || null,
        // If done, update status
        ...(progressData.type === "done" && {
          renderStatus: "done",
          downloadUrl: progressData.url || state.downloadUrl,
        }),
        // If error, update status
        ...(progressData.type === "error" && {
          renderStatus: "error",
          error: progressData.message || "Render failed",
        }),
      };
      console.log("🔄 REDUCER: GET_RENDER_PROGRESS_SUCCESS → new state:", {
        ...newState4,
        progress: newState4.progress,
        progressType: newState4.progressType,
      });
      return newState4;

    case GET_RENDER_PROGRESS_FAILURE:
      const newState5 = {
        ...state,
        renderStatus: "error",
        error: action.payload,
        progressType: "error",
      };
      console.log(
        "🔄 REDUCER: GET_RENDER_PROGRESS_FAILURE → new state:",
        newState5
      );
      return newState5;

    case GET_RENDER_DOWNLOAD_URL_REQUEST:
      return {
        ...state,
        // Keep existing state
      };

    case GET_RENDER_DOWNLOAD_URL_SUCCESS:
      return {
        ...state,
        downloadUrl: action.payload.downloadUrl,
        downloadUrlExpiresIn: action.payload.expiresIn,
      };

    case GET_RENDER_DOWNLOAD_URL_FAILURE:
      return {
        ...state,
        error: action.payload,
      };

    case RESET_RENDER_STATE:
      return initialState;

    default:
      return state;
  }
};

export default videoRenderReducer;
